/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ITheme, IStyle } from '@fluentui/react';
import { ILabelStyles } from '@fluentui/react/lib/Label';
import { FontSizes } from '../teams';

export function getEsignRecipientSectionLabelStyles(themeName: string, _theme: ITheme): ILabelStyles {
    const sectionLabelRootStyle: IStyle = {
        fontSize: FontSizes.size14,
        fontWeight: '500',
        display: 'inline-flex',
    };

    const sectionLabelStyles: ILabelStyles = {
        root: sectionLabelRootStyle,
    };

    if (themeName && _theme && _theme.palette) {
        const color = themeName === 'contrast' ? _theme.palette.black : _theme.palette.neutralPrimary;
        sectionLabelStyles.root = {
            ...sectionLabelRootStyle,
            selectors: {
                '&::after': { color: color, padding: 0 },
            },
        };
    }

    return sectionLabelStyles;
}
